export const ECOSYSTEM_CONTENT = Object.freeze({
  it: {
    ecosystem: {
      hero: {
        badge: 'Ecosistema',
        title: 'Come si divide davvero l’ecosistema BullVerge',
        copy:
          'I prodotti sono esperienze verticali, i moduli sono capacità riusabili, Aegis è il metodo che coordina risorse e flussi locali.',
        primary: 'Scopri i prodotti',
        secondary: 'Esplora i moduli'
      },
      promise: [
        { label: 'Locale prima di tutto', value: 'AI vicino ai dati' },
        { label: 'Basso consumo', value: 'Esecuzione efficiente' },
        { label: 'Impatto umano', value: 'Tecnologia utile sul campo' }
      ],
      productsTitle: 'Prodotti BullVerge',
      productsCopy:
        'Ogni prodotto porta la stessa base tecnologica in un contesto diverso: vita quotidiana, sicurezza personale, assistenza sanitaria, lavoro operativo, difesa o prototipazione edge AI.',
      modulesTitle: 'Capacità componibili',
      modulesCopy:
        'Core, Voce, Visione, Conoscenza, Horizon, PSIC e Pipeline ibride sono capacità componibili che Aegis coordina sui dispositivi BullVerge o su hardware partner.',
      impactTitle: 'Dove deve arrivare l’AI locale',
      impactCopy:
        'L’impatto nasce quando la stessa base tecnologica diventa utile in cura quotidiana, sicurezza personale, formazione, industria, difesa e comunità con meno accesso a infrastrutture costose.'
    },
    productsPage: {
      hero: {
        badge: 'Prodotti',
        title: 'Dispositivi e linee prodotto per portare AI locale nel mondo reale',
        copy:
          'Con Prometeo, Nemo, BackSense e Aura portiamo capacità intelligenti vicino a hardware, dati e utenti: AI compatta offline, routine e cura quotidiana, consapevolezza operativa e sicurezza personale.',
        primary: 'Esplora i moduli',
        secondary: 'Parla con noi'
      }
    },
    modulesPage: {
      hero: {
        badge: 'Moduli',
        title: 'Moduli BullVerge: cosa fanno e come diventano casi d’uso',
        copy:
          'Qui leggiamo Core locale, Voce, Visione, Conoscenza, Horizon, PSIC e Pipeline ibrida come leve operative: cosa fanno, a chi servono e come si combinano in prodotti, kiosk, postazioni o hardware partner.',
        primary: 'Scopri Aegis',
        secondary: 'Vedi i prodotti'
      }
    },
    academy: {
      hero: {
        badge: 'Academy',
        title: 'Ricerca, paper, FAQ e note pubbliche per capire come cresce BullVerge',
        copy:
          'Academy raccoglie papers, note R&D, domande frequenti, video-corsi e documentazione per partner, primi utilizzatori e interlocutori tecnici.',
        primary: 'Leggi i paper',
        secondary: 'Apri le FAQ'
      },
      cards: [
        {
          title: 'Paper tecnici',
          path: '/academy/papers',
          icon: 'paper',
          copy: 'White paper e documenti tecnici su edge AI, modelli integrati, RAG, PSIC e architetture locali.'
        },
        {
          title: 'Note di ricerca / R&D',
          path: '/academy',
          icon: 'tutorial',
          copy: 'Note sintetiche su prototipi, direzioni di ricerca, limiti tecnici, benchmark e scelte architetturali.'
        },
        {
          title: 'FAQ',
          path: '/academy/faq',
          icon: 'knowledge',
          copy: 'Risposte chiare su prodotti, tecnologia, privacy, partner, modello di business e preordine.'
        }
      ],
      researchNotes: [
        'Aegis come metodo di governance AI-aware per dispositivi locali',
        'Prometeo come prima manifestazione fisica dell’ecosistema',
        'Nemo e i flussi assistivi terapeutici',
        'BackSense e Aura come consapevolezza di quello che accade attorno a se'
      ]
    },
    faqPage: {
      hero: {
        badge: 'FAQ',
        title: 'Domande frequenti su BullVerge, prodotti, privacy e collaborazioni',
        copy:
          'Una lettura rapida per distinguere prodotti, moduli, Aegis, Academy e opportunità di partnership.'
      }
    },
    products: [
      {
        id: 'prometeo',
        name: 'Prometeo',
        icon: 'device',
        path: '/ecosystem/products/prometeo',
        eyebrow: 'Device edge AI portatile',
        title: 'Prometeo: AI locale in un dispositivo fisico',
        short:
          'Un mini cervello AI locale, compatto e pensato per uso offline, ricerca, primi utilizzatori, complottisti, survivalisti e ambienti a bassa connettività.',
        copy:
          'Con Prometeo portiamo il nostro stack edge AI in un dispositivo fisico: un’unità di intelligenza locale progettata per eseguire carichi AI vicino all’utente, all’hardware e ai dati. È la prima manifestazione concreta dell’ecosistema, non il suo limite.',
        detail:
          'Prometeo serve a rendere concreta la piattaforma BullVerge: un dispositivo fisico su cui testare AI locale, moduli componibili, interazione e governance senza dover dipendere sempre da cloud o infrastrutture esterne.',
        features: [
          'AI locale e privacy fin dalla progettazione',
          'Bassa latenza e uso orientato all’offline',
          'Dispositivo compatto per prototipi, ricerca e primi utilizzatori',
          'Base concreta per moduli e flussi BullVerge'
        ],
        contexts: ['Primi utilizzatori', 'Sviluppatori', 'Ricerca', 'Bassa connettività'],
        note:
          'Prometeo rende visibile lo stack BullVerge: moduli, governance e interazione locale in un dispositivo tangibile.'
      },
      {
        id: 'nemo',
        name: 'Nemo',
        icon: 'user',
        path: '/ecosystem/products/nemo',
        eyebrow: 'Assistente per la cura',
        title: 'Un assistente per terapia, routine e cura quotidiana',
        short:
          'Promemoria, supporto alla gestione di terapie farmacologiche, guida alle routine, notifiche e report per persone fragili, caregiver e famiglie, con approccio umano.',
        copy:
          'A volte un promemoria può cambiare una giornata. Nemo nasce per portare serenità, continuità e assistenza nella vita quotidiana, aiutando persone fragili, anziani, malati, caregiver e famiglie a gestire routine, orari, dosi e indicazioni semplici.',
        detail:
          'Nemo è pensato per ridurre dimenticanze, frammentazione e carico organizzativo nella cura quotidiana: promemoria, routine, terapie, dosi erogate, notifiche e report restano dentro un’esperienza semplice, orientata al supporto umano.',
        features: [
          'Promemoria, supporto alle terapie e guida alle routine',
          'Notifiche per famiglia e caregiver',
          'Interazione vocale e interfaccia semplice',
          'Elaborazione locale orientata alla privacy'
        ],
        contexts: ['Caregiver', 'Famiglie', 'Anziani', 'Routine quotidiane'],
        note:
          'Nemo agevola la gestione quotidiana, dà continuità alle routine e rende più leggibile il supporto alle persone fragili.'
      },
      {
        id: 'backsense',
        name: 'BackSense',
        icon: 'vision',
        path: '/ecosystem/products/backsense',
        eyebrow: 'Sistema aptico di consapevolezza',
        title: 'Consapevolezza dietro di sé, senza distogliere lo sguardo',
        short:
          'Un sistema aptico a 180 gradi per operatori, ambienti critici, lavoro operativo, soccorso e contesti di difesa.',
        copy:
          'BackSense dà agli operatori un nuovo senso: consapevolezza di ciò che accade dietro di loro senza togliere gli occhi da ciò che hanno davanti. Sensori, visione e feedback aptico localizzato aiutano a leggere lo spazio circostante in modo discreto e a mani libere.',
        detail:
          'BackSense lavora sul supporto situazionale: quando mani e sguardo devono restare sul compito principale, il feedback aptico aiuta a percepire eventi posteriori o laterali in modo discreto, immediato e integrato nel flusso operativo.',
        features: [
          'Feedback aptico localizzato',
          'Intensità proporzionale a distanza e rischio',
          'Fusione sensori/camera',
          'Elaborazione locale per sicurezza e operazioni sul campo'
        ],
        contexts: ['Operazioni sul campo', 'Industria', 'Soccorso', 'Contesti difesa'],
        note:
          'BackSense porta consapevolezza situazionale e feedback operativo in contesti in cui attenzione, postura e mani libere contano.'
      },
      {
        id: 'aura',
        name: 'Aura',
        icon: 'touchless',
        path: '/ecosystem/products/backsense/aura',
        eyebrow: 'Versione per sicurezza personale',
        title: 'La versione civile di BackSense per sicurezza personale e discrezione',
        short:
          'Consapevolezza, feedback aptico e SOS discreto per donne in situazioni di rischio, lavoratori isolati e mobilità urbana.',
        copy:
          'Aura è consapevolezza, discrezione e un secondo in più per reagire. Porta il concetto BackSense nel mondo civile con un design meno militare, più elegante e orientato alla libertà di movimento.',
        detail:
          'Aura porta la logica di BackSense in un contesto personale: avvisi discreti, consapevolezza e possibilità di segnalazione rapida, con un perimetro civile pensato per mobilità urbana, rientri serali e persone che lavorano o si muovono da sole.',
        features: [
          'Avvisi discreti e feedback aptico',
          'Modalità sicurezza personale e pulsante SOS',
          'Consapevolezza spaziale discreta in forma civile',
          'Elaborazione orientata alla privacy e design indossabile'
        ],
        contexts: ['Sicurezza personale', 'Rientri serali', 'Lavoratori isolati', 'Ambienti urbani'],
        note:
          'Aura unisce consapevolezza, discrezione e possibilità di avviso rapido in un formato civile e indossabile.'
      }
    ],
    modules: [
      { id: 'runtime', name: 'Core locale', icon: 'runtime', short: 'Orchestrazione locale di moduli, risorse, instradamento e carichi AI.' },
      { id: 'voice', name: 'Voce', icon: 'voice', short: 'Interazione vocale locale per comandi, assistenza e accessibilità.' },
      { id: 'vision', name: 'Visione', icon: 'vision', short: 'Lettura visuale, scene, segnali e supporto operativo.' },
      { id: 'knowledge', name: 'Conoscenza', icon: 'knowledge', short: 'Documenti e conoscenza privata consultabili localmente.' },
      { id: 'horizon', name: 'Horizon / controllo senza contatto', icon: 'touchless', short: 'Controllo a mani libere e interazione senza contatto.' },
      { id: 'psic', name: 'PSIC', icon: 'user', short: 'Classificazione intenti integrata e instradamento leggero.' },
      { id: 'hybrid', name: 'Pipeline ibrida', icon: 'hybrid', short: 'Servizi esterni solo dove aggiungono valore reale.' }
    ],
    impact: [
      { title: 'Sanità e cura', icon: 'user', copy: 'Routine, promemoria, supporto alle terapie, flussi per caregiver e consultazione locale di conoscenza sensibile.' },
      { title: 'Sicurezza personale', icon: 'touchless', copy: 'Avvisi, supporto, consapevolezza e interazioni rapide in contesti sensibili.' },
      { title: 'Lavoro e industria', icon: 'ops', copy: 'Supporto a mani libere, controllo locale e continuità operativa in ambienti complessi.' },
      { title: 'Difesa e operazioni sul campo', icon: 'patent', copy: 'AI locale per supporto operativo, bassa connettività e scenari mission-critical.' },
      { title: 'Formazione', icon: 'paper', copy: 'Accesso a strumenti intelligenti anche dove cloud e hardware costoso sono barriere.' },
      { title: 'Comunità meno servite', icon: 'team', copy: 'Tecnologie a basso consumo per portare AI dove infrastruttura e budget sono limitati.' }
    ],
    faqCategories: [
      {
        title: 'Prodotto',
        items: [
          {
            question: 'Che cos’è BullVerge?',
            answer:
              'In BullVerge costruiamo dispositivi, moduli e governance edge AI per dare intelligenza e abilità reali a dispositivi e macchine, rendendo l’AI più locale, privata e indipendente dalle connessioni.'
          },
          {
            question: 'Prometeo è un prodotto autonomo?',
            answer:
              'Sì. Prometeo è un dispositivo fisico autonomo e la prima manifestazione concreta dello stack BullVerge. Non è però l’unico prodotto: l’ecosistema include anche Nemo, BackSense, Aura, moduli e Aegis.'
          },
          {
            question: 'Qual è la differenza tra prodotti e moduli?',
            answer:
              'I prodotti sono esperienze o dispositivi completi. I moduli sono capacità componibili come Voce, Visione, Conoscenza, controllo senza contatto, PSIC e Pipeline ibrida, coordinate dal metodo Aegis.'
          },
          {
            question: 'Che cos’è Nemo?',
            answer:
              'Nemo è un assistente per la cura orientato a promemoria, routine, supporto alla gestione delle terapie, notifiche e flussi informativi per persone fragili, caregiver e famiglie.'
          },
          {
            question: 'Che cos’è BackSense?',
            answer:
              'BackSense è un sistema di consapevolezza aptica a 180 gradi pensato per supportare operatori e lavoratori in scenari dove occhi e mani devono restare liberi.'
          },
          {
            question: 'Che cos’è Aura?',
            answer:
              'Aura è la versione civile di BackSense per sicurezza personale: feedback discreto, consapevolezza, SOS e design più elegante per contesti urbani e personali.'
          }
        ]
      },
      {
        title: 'Tecnologia',
        items: [
          {
            question: 'Che cos’è Aegis?',
            answer:
              'Aegis è il metodo di governance consapevole dell’AI dietro BullVerge: decide cosa e come instradare, gestisce risorse hardware, carichi AI locali, flussi dati e moduli per ridurre latenza, dipendenza cloud e dispersione tecnica.'
          },
          {
            question: 'BullVerge può funzionare senza cloud?',
            answer:
              'L’approccio parte dal locale: molte funzioni sono pensate per lavorare sul dispositivo o in bassa connettività. L’ibrido entra solo quando aggiunge valore reale.'
          },
          {
            question: 'Le tecnologie BullVerge possono integrarsi in hardware terzo?',
            answer:
              'Sì, la direzione è modulare. Alcuni moduli e flussi possono essere adattati a hardware partner, kiosk, appliance o dispositivi verticali.'
          }
        ]
      },
      {
        title: 'Privacy',
        items: [
          {
            question: 'Come gestisce BullVerge la privacy?',
            answer:
              'La privacy è progettata riducendo la dipendenza da piattaforme centralizzate e portando elaborazione, dati e conoscenza più vicino al dispositivo quando possibile.'
          },
          {
            question: 'Come viene usato Nemo nei flussi di cura quotidiana?',
            answer:
              'Nemo organizza promemoria, routine, indicazioni semplici e flussi informativi per rendere più continua la gestione quotidiana di persone fragili, caregiver e famiglie.'
          },
          {
            question: 'Come viene usato BackSense nei contesti operativi?',
            answer:
              'BackSense porta feedback aptico e consapevolezza situazionale a operatori e lavoratori che devono mantenere occhi e mani sul compito principale.'
          }
        ]
      },
      {
        title: 'Partnership e business',
        items: [
          {
            question: 'Qual è il modello di business?',
            answer:
              'Lavoriamo su dispositivi, licenze tecnologiche, moduli, integrazioni verticali, partnership e percorsi di sviluppo con aziende o interlocutori tecnici.'
          },
          {
            question: 'Come possono collaborare i partner?',
            answer:
              'Partner industriali, sanitari, formativi, difesa e OEM possono contattarci per progetti pilota, integrazioni hardware, casi d’uso verticali e co-progettazione.'
          },
          {
            question: 'Come si può supportare il progetto?',
            answer:
              'Puoi seguire BullVerge, entrare in contatto con noi, sostenere il progetto e partecipare alle prossime fasi pubbliche legate a Prometeo e all’ecosistema.'
          }
        ]
      }
    ]
  },
  en: {
    ecosystem: {
      hero: {
        badge: 'Ecosystem',
        title: 'How the BullVerge ecosystem is actually structured',
        copy:
          'This page gives BullVerge a clear structure: products are vertical experiences, modules are reusable capabilities, and Aegis is the method that coordinates local resources and flows. The home orients; here we enter the system.',
        primary: 'Discover products',
        secondary: 'Explore modules'
      },
      promise: [
        { label: 'Local-first', value: 'AI close to data' },
        { label: 'Low-power', value: 'Efficient execution' },
        { label: 'Human impact', value: 'Technology useful in the field' }
      ],
      productsTitle: 'BullVerge products',
      productsCopy:
        'Each product brings the same technology foundation into a different context: everyday life, personal safety, healthcare assistance, operational work, defense or edge AI prototyping.',
      modulesTitle: 'Composable capabilities',
      modulesCopy:
        'Core, Voice, Vision, Knowledge, Horizon, PSIC and Hybrid Pipelines are composable capabilities coordinated by Aegis across BullVerge devices or partner hardware.',
      impactTitle: 'Where local AI must arrive',
      impactCopy:
        'Impact emerges when the same technology foundation becomes useful across everyday care, personal safety, education, industry, defense and communities with limited access to expensive infrastructure.'
    },
    productsPage: {
      hero: {
        badge: 'Products',
        title: 'Devices and product lines built to bring local AI into the real world.',
        copy:
          'With Prometeo, Nemo, BackSense and Aura, we bring intelligent capabilities closer to hardware, data and users: compact offline AI, everyday care routines, operational awareness and personal safety.',
        primary: 'Explore modules',
        secondary: 'Talk to us'
      }
    },
    modulesPage: {
      hero: {
        badge: 'Modules',
        title: 'BullVerge modules: what they do and how they become use cases',
        copy:
          'Here we read Local Core, Voice, Vision, Knowledge, Horizon, PSIC and Hybrid Pipeline as operating levers: what they do, who they serve and how they combine into products, kiosks, workstations or partner hardware.',
        primary: 'Discover Aegis',
        secondary: 'View products'
      }
    },
    academy: {
      hero: {
        badge: 'Academy',
        title: 'Research, papers, FAQ and public notes to understand how BullVerge grows.',
        copy:
          'Academy collects papers, R&D notes, frequently asked questions and readable documentation for partners, early adopters and technical stakeholders.',
        primary: 'Read papers',
        secondary: 'Open FAQ'
      },
      cards: [
        {
          title: 'Papers',
          path: '/academy/papers',
          icon: 'paper',
          copy: 'White papers and technical documents on edge AI, embedded models, RAG, PSIC and local architectures.'
        },
        {
          title: 'Research Notes / R&D',
          path: '/academy',
          icon: 'tutorial',
          copy: 'Short notes on prototypes, research directions, technical limits, benchmarks and architecture choices.'
        },
        {
          title: 'FAQ',
          path: '/academy/faq',
          icon: 'knowledge',
          copy: 'Clear answers about products, technology, privacy, partners, business model and preorder.'
        }
      ],
      researchNotes: [
        'Aegis as an AI-aware governance method for local devices',
        'Prometeo as the first physical expression of the ecosystem',
        'Nemo and assistive workflows for everyday care continuity',
        'BackSense and Aura as haptic awareness for operational and personal contexts'
      ]
    },
    faqPage: {
      hero: {
        badge: 'FAQ',
        title: 'Frequently asked questions about BullVerge, products, privacy and collaborations.',
        copy:
        'A quick way to distinguish products, modules, Aegis, Academy and partnership opportunities.'
      }
    },
    products: [
      {
        id: 'prometeo',
        name: 'Prometeo',
        icon: 'device',
        path: '/ecosystem/products/prometeo',
        eyebrow: 'Portable edge AI device',
        title: 'Prometeo: local AI in a physical device.',
        short:
          'A compact, offline-first local AI mini brain for research, early adopters, privacy-first users, resilience-minded users and low-connectivity environments.',
        copy:
          'With Prometeo, we bring the BullVerge edge AI stack into a physical device: a local intelligence unit designed to run AI workloads close to the user, the hardware and the data. It is the first concrete expression of the ecosystem.',
        detail:
          'Prometeo makes the BullVerge platform concrete: a physical device for testing local AI, composable modules, interaction and governance while keeping core capabilities close to the device.',
        features: [
          'Local AI and privacy by design',
          'Low latency and offline-first use',
          'Compact device for prototypes, research and early adopters',
          'Concrete base for BullVerge modules and workflows'
        ],
        contexts: ['Early adopters', 'Developers', 'Research', 'Low connectivity'],
        note:
          'Prometeo makes the BullVerge stack visible: core, modules and local interaction inside a tangible device.'
      },
      {
        id: 'nemo',
        name: 'Nemo',
        icon: 'user',
        path: '/ecosystem/products/nemo',
        eyebrow: 'Care assistant',
        title: 'An assistant for therapy routines, reminders and everyday care.',
        short:
          'Reminders, medication routines, guidance, notifications and reports for people who need support, caregivers and families, with a human approach.',
        copy:
          'Sometimes a reminder can change a day. Nemo brings calm, continuity and assistance into everyday life, helping people who need support, older adults, caregivers and families manage routines, schedules, doses and simple instructions.',
        detail:
          'Nemo reduces forgetfulness, fragmentation and organizational load in care routines: reminders, routines, notifications and reports stay inside a simple, readable experience built around human support.',
        features: [
          'Medication reminders, therapy routines and daily guidance',
          'Notifications for family and caregivers',
          'Voice interaction and simple interface',
          'Local processing oriented around privacy'
        ],
        contexts: ['Caregivers', 'Families', 'Older adults', 'Everyday routines'],
        note:
          'Nemo makes everyday management clearer, gives continuity to routines and supports care around people who need assistance.'
      },
      {
        id: 'backsense',
        name: 'BackSense',
        icon: 'vision',
        path: '/ecosystem/products/backsense',
        eyebrow: '180-degree haptic awareness system',
        title: 'Rear awareness while your eyes stay on the task.',
        short:
          'A 180-degree haptic awareness system for operators, critical environments, field work, rescue and defense contexts.',
        copy:
          'BackSense gives operators an additional sense: awareness of what happens behind them while their eyes remain on the task ahead. Sensors, vision and localized haptic feedback help read the surrounding space in a discreet, hands-free way.',
        detail:
          'BackSense focuses on situational support: when hands and eyes must stay on the main task, haptic feedback helps perceive rear or lateral events in a discreet, immediate way integrated into the operating flow.',
        features: [
          'Localized haptic feedback',
          'Intensity proportional to distance and risk',
          'Sensor/camera fusion',
          'Local processing for safety and field operations'
        ],
        contexts: ['Field operations', 'Industry', 'Rescue', 'Defense environments'],
        note:
          'BackSense brings situational awareness and operational feedback into contexts where attention, posture and free hands matter.'
      },
      {
        id: 'aura',
        name: 'Aura',
        icon: 'touchless',
        path: '/ecosystem/products/backsense/aura',
        eyebrow: 'Personal safety edition',
        title: 'The civilian version of BackSense for personal safety and discretion.',
        short:
          'Awareness, haptic feedback and discreet SOS for women in risky situations, isolated workers and urban mobility.',
        copy:
          'Aura is awareness, discretion and one more second to react. It brings the BackSense concept into civilian life with a less military, more elegant design oriented around freedom of movement.',
        detail:
          'Aura brings the BackSense logic into a personal context: discreet alerts, awareness and quick signaling capability, with a civilian scope designed for urban mobility, night returns and people who work or move alone.',
        features: [
          'Discreet alerts and haptic feedback',
          'Personal safety mode and SOS button',
          'Discreet spatial awareness in a civilian form',
          'Privacy-first processing and wearable design'
        ],
        contexts: ['Personal safety', 'Night returns', 'Isolated workers', 'Urban environments'],
        note:
          'Aura combines awareness, discretion and quick alerting capability in a civilian wearable format.'
      }
    ],
    modules: [
      { id: 'runtime', name: 'Local Core', icon: 'runtime', short: 'Local orchestration of modules, resources, routing and AI workloads.' },
      { id: 'voice', name: 'Voice', icon: 'voice', short: 'Local voice interaction for commands, assistance and accessibility.' },
      { id: 'vision', name: 'Vision', icon: 'vision', short: 'Visual reading, scenes, signals and operational support.' },
      { id: 'knowledge', name: 'Knowledge', icon: 'knowledge', short: 'Private documents and knowledge available locally.' },
      { id: 'horizon', name: 'Touchless / Horizon', icon: 'touchless', short: 'Hands-free control and contactless interaction.' },
      { id: 'psic', name: 'PSIC', icon: 'user', short: 'Embedded intent classification and lightweight routing.' },
      { id: 'hybrid', name: 'Hybrid Pipeline', icon: 'hybrid', short: 'External services only where they add real value.' }
    ],
    impact: [
      { title: 'Healthcare & care', icon: 'user', copy: 'Routines, reminders, therapy workflows, caregiver coordination and local consultation of sensitive knowledge.' },
      { title: 'Personal safety', icon: 'touchless', copy: 'Discreet alerts, awareness and fast interactions for people in sensitive contexts.' },
      { title: 'Workers & industry', icon: 'ops', copy: 'Hands-free support, local control and operational continuity in complex environments.' },
      { title: 'Defense & field operations', icon: 'patent', copy: 'Local AI for operator support, low connectivity and mission-critical scenarios.' },
      { title: 'Education', icon: 'paper', copy: 'Access to intelligent tools where cloud and expensive hardware are barriers.' },
      { title: 'Underserved communities', icon: 'team', copy: 'Low-power technologies to bring AI where infrastructure and budgets are limited.' }
    ],
    faqCategories: [
      {
        title: 'Product',
        items: [
          {
            question: 'What is BullVerge?',
            answer:
              'At BullVerge, we build edge AI devices, modules and governance technologies to give real intelligence and abilities to devices and machines, making AI more local, private and independent from connectivity.'
          },
          {
            question: 'Is Prometeo a standalone product?',
            answer:
              'Yes. Prometeo is a standalone physical device and the first concrete expression of the BullVerge stack. The broader ecosystem also includes Nemo, BackSense, Aura, modules and Aegis.'
          },
          {
            question: 'What is the difference between products and modules?',
            answer:
              'Products are complete experiences or devices. Modules are composable capabilities such as Voice, Vision, Knowledge, Touchless, PSIC and Hybrid Pipeline, coordinated by the Aegis method.'
          },
          {
            question: 'What is Nemo?',
            answer:
              'Nemo is a care assistant for reminders, routines, therapy workflows, notifications and information flows for people who need support, caregivers and families.'
          },
          {
            question: 'What is BackSense?',
            answer:
              'BackSense is a 180-degree haptic awareness system designed to support operators and workers in scenarios where eyes and hands must remain free.'
          },
          {
            question: 'What is Aura?',
            answer:
              'Aura is the civilian personal-safety version of BackSense: discreet feedback, awareness, SOS and a more elegant design for urban and personal contexts.'
          }
        ]
      },
      {
        title: 'Technology',
        items: [
          {
            question: 'What is Aegis?',
            answer:
              'Aegis is the AI-aware governance method behind BullVerge: it decides what and how to route, manages hardware resources, local AI workloads, data flows and modules to reduce latency, cloud dependence and technical fragmentation.'
          },
          {
            question: 'Can BullVerge operate offline or in low connectivity?',
            answer:
              'Yes. The approach is local-first: many functions are designed to run on-device or in low-connectivity conditions. Hybrid services enter where they add real value.'
          },
          {
            question: 'Can BullVerge technologies be integrated into third-party hardware?',
            answer:
              'Yes, the direction is modular. Some modules and workflows can be adapted to partner hardware, kiosks, appliances or vertical devices.'
          }
        ]
      },
      {
        title: 'Privacy',
        items: [
          {
            question: 'How does BullVerge handle privacy?',
            answer:
              'Privacy is designed by reducing dependence on centralized platforms and bringing processing, data and knowledge closer to the device whenever possible.'
          },
          {
            question: 'How is Nemo used in everyday care workflows?',
            answer:
              'Nemo organizes reminders, routines, simple guidance and information flows to make everyday management clearer for people who need support, caregivers and families.'
          },
          {
            question: 'How is BackSense used in operational contexts?',
            answer:
              'BackSense brings haptic feedback and situational awareness to operators and workers who need to keep eyes and hands on the main task.'
          }
        ]
      },
      {
        title: 'Partnerships & Business',
        items: [
          {
            question: 'What is the business model?',
            answer:
              'We work across devices, technology licensing, modules, vertical integrations, partnerships and development paths with companies or technical stakeholders.'
          },
          {
            question: 'How can partners collaborate?',
            answer:
              'Industrial, healthcare, education, defense and OEM partners can contact us for pilots, hardware integrations, vertical use cases and co-design.'
          },
          {
            question: 'How can I support the project?',
            answer:
              'You can follow BullVerge, get in touch with us, support the project and participate in the next public phases around Prometeo and the ecosystem.'
          }
        ]
      }
    ]
  }
})

export function getEcosystemContent(locale) {
  return ECOSYSTEM_CONTENT[locale] || ECOSYSTEM_CONTENT.it
}

export function getProductById(locale, productId) {
  const content = getEcosystemContent(locale)
  return content.products.find((product) => product.id === productId) || content.products[0]
}
